"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPodcastComponent = renderPodcastComponent;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const webexUI_1 = require("webexUI");
const components_1 = require("./components");
const PodcastPlayer = ({ podcast, orderOnPage }) => {
    const audioRef = React.useRef(null);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const [isEnded, setIsEnded] = React.useState(false);
    const [currentTime, setCurrentTime] = React.useState(0);
    const [duration, setDuration] = React.useState(0);
    const [isMobile, setIsMobile] = React.useState(() => (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.Tablet));
    const updateSize = (0, webexUI_1.throttle)(() => setIsMobile((0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.Tablet)), 100);
    React.useLayoutEffect(() => {
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, [updateSize]);
    React.useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            const handlePlay = () => setIsPlaying(true);
            const handlePause = () => setIsPlaying(false);
            audio.addEventListener('play', handlePlay);
            audio.addEventListener('pause', handlePause);
            return () => {
                audio.removeEventListener('play', handlePlay);
                audio.removeEventListener('pause', handlePause);
            };
        }
    }, []);
    const pauseAllPlayers = React.useCallback((event) => {
        const audio = audioRef.current;
        if (!audio)
            return;
        if (event.detail.playedPlayerOrder === orderOnPage) {
            audio.play();
        }
        else {
            audio.pause();
        }
    }, [orderOnPage]);
    React.useEffect(() => {
        window.addEventListener('pausePlayer', pauseAllPlayers);
        return () => {
            window.removeEventListener('pausePlayer', pauseAllPlayers);
        };
    }, [pauseAllPlayers]);
    const handleTimeUpdate = React.useCallback(() => {
        if (audioRef.current) {
            setCurrentTime(audioRef.current.currentTime);
        }
    }, []);
    const handleLoadedMetadata = React.useCallback(() => {
        if (audioRef.current) {
            setDuration(audioRef.current.duration);
        }
    }, []);
    const handleAudioEnded = React.useCallback(() => {
        if (audioRef.current) {
            setCurrentTime(0);
            setIsEnded(true);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "podcast-player flex-center bg-surface-primary border-primary p-2xl min-w-[306px] rounded-3xl border", "data-testid": "podcast", children: [(0, jsx_runtime_1.jsx)(components_1.PodcastPlayerInfo, { title: podcast.title, link: podcast.link, audioRef: audioRef, currentTime: currentTime, duration: duration, setCurrentTime: setCurrentTime }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-start justify-between", children: [(0, jsx_runtime_1.jsx)(components_1.PodcastPlayerPlayButton, { isEnded: isEnded, isPlaying: isPlaying, audioRef: audioRef, orderOnPage: orderOnPage, setIsEnded: setIsEnded, currentTime: currentTime, duration: duration }), (0, jsx_runtime_1.jsx)(components_1.PodcastPlayerControllers, { podcastLink: podcast.podcastLink, audioRef: audioRef })] }), (0, jsx_runtime_1.jsx)("audio", { crossOrigin: "anonymous", ref: audioRef, src: podcast.src, onEnded: handleAudioEnded, onTimeUpdate: handleTimeUpdate, onLoadedMetadata: handleLoadedMetadata })] }));
};
function renderPodcastComponent(element, podcast, orderOnPage) {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(PodcastPlayer, { podcast: podcast, orderOnPage: orderOnPage }), element);
}
